import { useCallback } from "react";
import Toaster from "components/Toaster";

/**
 * Hook that provides toast notification methods
 * Wraps the Toaster component for easier testing and consistent usage
 */
export const useToast = () => {
  const showSuccess = useCallback((title: string, description?: string) => {
    return Toaster.success(title, description);
  }, []);

  const showError = useCallback((title: string, description?: string) => {
    return Toaster.error(title, description);
  }, []);

  const showWarning = useCallback((title: string, description?: string) => {
    return Toaster.warning(title, description);
  }, []);

  const showInfo = useCallback((title: string, description?: string) => {
    return Toaster.info(title, description);
  }, []);

  const dismiss = useCallback((toastId?: string | number) => {
    return Toaster.dismiss(toastId);
  }, []);

  return {
    showSuccess,
    showError,
    showWarning,
    showInfo,
    dismiss,
  };
};
